import { getExternalBaseUrl } from './services/url-service'

export default function getPersonAboutPageUrl(pid: string): string {
  return `${getExternalBaseUrl()}/tree/person/about/${pid}`
}
